export const getToken = (state) => { return state.token }

export const getAuth = (state) => { return state.auth }


// WEBPACK FOOTER //
// ./src/store/main/getters.js